const NavLinks = {
  COURSE_ENROLLMENTS_SEARCH: '/courseenrollments/search',
  COURSE_ENROLLMENTS_MANAGE: '/courseenrollments/manage',
  COURSE_ENROLLMENTS_MANAGE_DETAIL: '/courseenrollments/manage/detail',
  COURSE_ENROLLMENTS_MANAGE_ADD_NO_COMPLETION: '/courseenrollments/manage/addnocompletion'
};

export default NavLinks;